import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import LinkedInIcon from '@material-ui/icons/LinkedIn';

import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import Button from '@material-ui/core/Button';
import { useHistory } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
	overlayButton: {
		textAlign: 'center',
		margin: theme.spacing(2),
	},
}));

const LinkedInDialog = ({ openLinkedInDialog, setOpenLinkedInDialog }) => {
	const classes = useStyles();
	const history = useHistory();

	const generateURL = () => {
		const url = `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${process.env.REACT_APP_LINKEDIN_CLIENT_ID}&scope=r_liteprofile%20r_emailaddress&state=${process.env.REACT_APP_LINKEDIN_REDIRECT_URL_AGENT}&redirect_uri=${process.env.REACT_APP_LINKEDIN_REDIRECT_URL}`;
		console.log('LinkedInDialog url', url);
		return url;
	};

	const handleCloseLinkedInDialog = () => {
		setOpenLinkedInDialog(false);
	};

	const handleIamGood = () => {
		setOpenLinkedInDialog(false);
		history.push('/editor');
	};

	return (
		<Dialog
			onClose={handleCloseLinkedInDialog}
			aria-labelledby="simple-dialog-title"
			open={openLinkedInDialog}
		>
			<DialogTitle id="simple-dialog-title">Connect LinkedIn</DialogTitle>
			<DialogContent>
				<div>
					<Typography variant="body1">
						LinkedIn Profile to personal website in Seconds
					</Typography>
				</div>
				<div>
					<Button
						variant="contained"
						color="primary"
						href={generateURL()}
						startIcon={<LinkedInIcon />}
						className={classes.overlayButton}
					>
						CONNECT TO LinkedIn
					</Button>
					<Button
						variant="contained"
						color="secondary"
						onClick={handleIamGood}
						className={classes.overlayButton}
					>
						NO, I AM GOOD
					</Button>
				</div>
			</DialogContent>
		</Dialog>
	);
};

LinkedInDialog.propTypes = {
	openLinkedInDialog: PropTypes.bool.isRequired,
	setOpenLinkedInDialog: PropTypes.func.isRequired,
};

export default LinkedInDialog;
